import TalentNetworkPage from '../../../js/pages/TalentNetworkPage';

export default TalentNetworkPage;
